import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterOutlet } from '@angular/router'

import { HlmToaster } from '@yoshu-lib/ui/sonner/src'

import { environment } from '../environments/environment'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmToaster],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title)

  readonly currentEnvironment = environment.name

  ngOnInit() {
    if (this.currentEnvironment !== 'production') {
      const title = this.titleService.getTitle()
      this.titleService.setTitle(`[${this.currentEnvironment.toUpperCase()}] - ${title}`)
    }
  }
}
